export const MAX_DAYS_IN_MONTH = 31;

export const DELAY_FOR_KEY_PRESS = 100;

export enum EMoveDirection {
  left = 'left',
  right = 'right',
}
